function displayPopupWL(element, event) {
    for (let index = 0; index <= 3; index++) {
        if (element.classList.contains("product-card-content")) {
            console.log("yep");
            break;
        } else {
            element = element.parentNode;
        }
    }
    const popupWL = element.parentNode.querySelector(".popup-wishlist-container");

    if (popupWL) {
        popupWL.classList.add("show");
    }
}

function hidePopupWL(element, event) {
    const popupWL = element.parentNode.parentNode;

    if (popupWL) {
        popupWL.classList.remove("show");
    }
}

function sendPopupWL(element, event, productID) {
    // for (let index = 0; index <= 3; index++) {
    //     if (element.classList.contains("product-card-content")) {
    //         console.log("yep");
    //         break;
    //     } else {
    //         element = element.parentNode;
    //     }
    // }
    // const selectElem = element.querySelector(".popup-wishlist-content .product-select");
    // var selectVal = 0;
    // const wlButton = element.querySelector("wishlist-button-collection");

    // if (selectElem && wlButton) {
    //     selectVal = selectElem.value;
    //     wlButton.dataset.VariantId = selectVal;
    //     wlButton.click();
    //     console.log("ID produit => ", productID);
    //     console.log("variante => ", selectVal);
    // }
}

/* START TO HANDLE AGREEMENTS */
let agreements = [
    [
        '#checkout', // cta
        'cart-main-' // prefix
    ],
    [
        '#CartDrawer-Checkout', // cta
        'cart-drawer-' // prefix
    ]
]

function setAgreements() {
    agreements.forEach(agreement => {
        if(document.querySelector(agreement[0]) === null) {
            return;
        }

        document.querySelector('body').removeEventListener('click', document.querySelector(agreement[0]));
        setAgreementEvent(agreement[0], agreement[1]);
    });
}

function setAgreementEvent(cta, prefixID) {
    document.querySelector(cta).addEventListener('click', function(e) {
        if(!document.querySelector("#" + prefixID + "-agree").checked) {
            e.preventDefault();
            e.stopPropagation();
            document.querySelector("#" + prefixID + "terms_and_condition_required").style.display = "block";
        }
    });
}

function setMutationObserverForAgreementsInDrawerCart() {
    const targetNode = document.querySelector('#CartDrawer');

    if(targetNode === null) {
        return;
    }

    const config = { attributes: true, childList: true, subtree: true };

    const callback = function(mutationsList, observer) {
        for(const mutation of mutationsList) {
            if (mutation.type === 'childList') {
                setAgreements();
            }
        }
    };

    const observer = new MutationObserver(callback);
    observer.observe(targetNode, config);
}

document.addEventListener("DOMContentLoaded", () => {
    setMutationObserverForAgreementsInDrawerCart();
    setAgreements();
});
/* END TO HANDLE AGREEMENTS */

function launchSearch() {
    if (window.innerWidth > 990) {
        var searchBtn = document.querySelector("header > .header__icons .header__search .search-modal__form .search__button");

        if (searchBtn) {
            searchBtn.click();
        }
    } else {
        var searchBtn = document.querySelector("header > header-drawer .search-modal__form .search__button");

        if (searchBtn) {
            searchBtn.click();
        }        
    }
}

function redirectWhenRolex() {
    const searchForms = document.querySelectorAll('form[action*="/search"]');

    if (searchForms) {
        searchForms.forEach(e => {
            e.addEventListener("submit", function(event) {
                var query = event.target.querySelector(".search__input.field__input");

                if (query) {
                    if (query.value == "rolex") {
                        event.preventDefault();
                        event.stopPropagation();
                        if (document.documentElement.lang == "fr") {
                            window.location.href = "https://arije-refonte.myshopify.com/pages/rolex-discover";
                        } else {
                            window.location.href = "https://arije-refonte.myshopify.com/en/pages/rolex-discover";
                        }
                    }
                }
            });
        });
    }
}

window.addEventListener("load", redirectWhenRolex);

function waitForElement(selector, callback) {
    const interval = setInterval(() => {
        const element = document.querySelector(selector);
        if (element) {
            clearInterval(interval);
            callback(element);
        }
    }, 100); // Check every 100ms
}

// Usage
waitForElement('.widget_inner > h2', (h2Elem) => {
    console.log("h2Elem exists");
    var pElem = document.createElement("p");
    
    pElem.innerHTML = h2Elem.innerHTML;
    for (j = 0; j < h2Elem.attributes.length; j++){
        pElem.setAttribute(h2Elem.attributes.item(j).name, h2Elem.attributes.item(j).value);
    }
    h2Elem.replaceWith(pElem);
    console.log("replaced !");
});

window.addEventListener("load", function() {
    var urlcourante = document.location.href;
    const filterAvailability = document.querySelector(".filter-available");

    if (filterAvailability && !urlcourante.includes("/search") && !urlcourante.includes("filter.v.availability")) {
        filterAvailability.click();
    }
});

function showPopupAppointment() {
    const popupAppointment = document.querySelector(".appointment-container");

    if (popupAppointment) {
      popupAppointment.classList.toggle("show");
    }
}

function hidePopupAppointment() {
    const popupAppointment = document.querySelector(".appointment-container");

    if (popupAppointment) {
        popupAppointment.classList.remove("show");
    }
}
function toggleCalendar(id) {
    const backFromModule = document.querySelector("#slotsRootEmbeded .widget_inner .back_block");
    const popupAppointment = document.querySelector(".appointment-container .popup-appointment-container");

    if (backFromModule) {
        backFromModule.click();
    } else {
        if (popupAppointment) {
            popupAppointment.classList.toggle("show-calendar");
        }
        if (id) {
            selectStore(id);
        }
    }
}
function selectStore(storeName) {

        $(".popup-appointment-container .schedule_time_wrapper_select").click();
        const selectElemVals = document.querySelectorAll(".popup-appointment-container .schedule_time_wrapper_select #react-select-2-listbox div div");

        if (selectElemVals) {
            console.log(selectElemVals);
        }
    
}

function showCalendar(id) {
    const popupAppointment = document.querySelector(".appointment-container");
    const popupAppointmentCalendar = document.querySelector(".appointment-container .popup-appointment-container");

    if (popupAppointment) {
      popupAppointment.classList.toggle("show");
      if (!popupAppointmentCalendar.classList.contains("show-calendar")) {
        popupAppointmentCalendar.classList.add("show-calendar");
      }
    }
    if (id) {
        selectStore(id);
    }
}

function backToTop() {
    document.body.scrollTo({
        top: 0,
        behavior: "smooth"
    })// For Safari
        document.documentElement.scrollTo({
        top: 0,
        behavior: "smooth"
    })// For Chrome, Firefox, IE and Opera
}

function handleENLinks() {
    var aTags;

    if (document.documentElement.lang != "fr") {
        aTags = document.querySelectorAll("a");
    }

    if (aTags) {
        aTags.forEach(e => {
            var lien = e.href;
            
            if (lien.includes(".com/") && !lien.includes(".com/en/")) {
                lien = lien.replace(".com/", ".com/en/");
            }
        });
    }
}

window.addEventListener("load", handleENLinks);

function boldArijeInP() {
    if(isRolexPage) {
        return;
    }

    const pTags = document.querySelectorAll("p");

    if (pTags) {
        pTags.forEach(e => {
            var text = e.innerHTML;

            if (text.includes("arije")) {
                text = text.replace("arije", "<strong>arije</strong>");
                e.innerHTML = text;
            }
        });
    }
}

window.addEventListener("load", boldArijeInP);